<template>
  <div class="import-actions-wrap">
    <div class="import-btn-grid">
      <AllCorrect v-if="!(errors && errors.length)" />
      <ErrorsAlert v-else :errors="errors" />
      <div class="import-actions-buttons">
        <Button type="ghost" size="small" icon="trash" @click="deleteProjectHandler">
          {{ $t('Delete project') }}
        </Button>
        <Button
          id="import-btn"
          type="primary"
          size="large"
          :disabled="!!(errors && errors.length)"
          @click="$emit('import')"
        >
          {{ $t('Import') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
  import Button from '@/components/ui-v2/Button';
  import AllCorrect from '@/components/import/validation-alerts/AllCorrect';
  import ErrorsAlert from '@/components/import/validation-alerts/ErrorsAlert';
  import { mapActions } from 'vuex';

  export default {
    name: 'ImportActions',
    components: {
      ErrorsAlert,
      AllCorrect,
      Button,
    },
    props: {
      errors: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      ...mapActions({
        confirm: 'confirmModal/openModal',
      }),
      deleteProjectHandler() {
        this.confirm({
          title: this.$t('Are you sure you want to delete this project?'),
          actionText: this.$t('Delete project'),
          description: this.$t('You will lose all your imported data.'),
          action: () => {
            this.$emit('delete-project');
          },
        });
      },
    },
  };
</script>
